export const pluscodeMap: string[][] = [
    [
        "22",
        "23",
        "24",
        "25",
        "32",
        "33",
        "34",
        "35",
        "42",
        "43",
        "44",
        "45",
        "52",
        "53",
        "54",
        "55",
    ],
    [
        "26",
        "27",
        "28",
        "29",
        "36",
        "37",
        "38",
        "39",
        "46",
        "47",
        "48",
        "49",
        "56",
        "57",
        "58",
        "59",
    ],
    [
        "2C",
        "2F",
        "2G",
        "2H",
        "3C",
        "3F",
        "3G",
        "3H",
        "4C",
        "4F",
        "4G",
        "4H",
        "5C",
        "5F",
        "5G",
        "5H",
    ],
    [
        "2J",
        "2M",
        "2P",
        "2Q",
        "3J",
        "3M",
        "3P",
        "3Q",
        "4J",
        "4M",
        "4P",
        "4Q",
        "5J",
        "5M",
        "5P",
        "5Q",
    ],
    [
        "2R",
        "2V",
        "2W",
        "2X",
        "3R",
        "3V",
        "3W",
        "3X",
        "4R",
        "4V",
        "4W",
        "4X",
        "5R",
        "5V",
        "5W",
        "5X",
    ],
    [
        "62",
        "63",
        "64",
        "65",
        "72",
        "73",
        "74",
        "75",
        "82",
        "83",
        "84",
        "85",
        "92",
        "93",
        "94",
        "95",
    ],
    [
        "66",
        "67",
        "68",
        "69",
        "76",
        "77",
        "78",
        "79",
        "86",
        "87",
        "88",
        "89",
        "96",
        "97",
        "98",
        "99",
    ],
    [
        "6C",
        "6F",
        "6G",
        "6H",
        "7C",
        "7F",
        "7G",
        "7H",
        "8C",
        "8F",
        "8G",
        "8H",
        "9C",
        "9F",
        "9G",
        "9H",
    ],
    [
        "6J",
        "6M",
        "6P",
        "6Q",
        "7J",
        "7M",
        "7P",
        "7Q",
        "8J",
        "8M",
        "8P",
        "8Q",
        "9J",
        "9M",
        "9P",
        "9Q",
    ],
    [
        "6R",
        "6V",
        "6W",
        "6X",
        "7R",
        "7V",
        "7W",
        "7X",
        "8R",
        "8V",
        "8W",
        "8X",
        "9R",
        "9V",
        "9W",
        "9X",
    ],
    [
        "C2",
        "C3",
        "C4",
        "C5",
        "F2",
        "F3",
        "F4",
        "F5",
        "G2",
        "G3",
        "G4",
        "G5",
        "H2",
        "H3",
        "H4",
        "H5",
    ],
    [
        "C6",
        "C7",
        "C8",
        "C9",
        "F6",
        "F7",
        "F8",
        "F9",
        "G6",
        "G7",
        "G8",
        "G9",
        "H6",
        "H7",
        "H8",
        "H9",
    ],
    [
        "CC",
        "CF",
        "CG",
        "CH",
        "FC",
        "FF",
        "FG",
        "FH",
        "GC",
        "GF",
        "GG",
        "GH",
        "HC",
        "HF",
        "HG",
        "HH",
    ],
    [
        "CJ",
        "CM",
        "CP",
        "CQ",
        "FJ",
        "FM",
        "FP",
        "FQ",
        "GJ",
        "GM",
        "GP",
        "GQ",
        "HJ",
        "HM",
        "HP",
        "HQ",
    ],
    [
        "CR",
        "CV",
        "CW",
        "CX",
        "FR",
        "FV",
        "FW",
        "FX",
        "GR",
        "GV",
        "GW",
        "GX",
        "HR",
        "HV",
        "HW",
        "HX",
    ],
    [
        "J2",
        "J3",
        "J4",
        "J5",
        "M2",
        "M3",
        "M4",
        "M5",
        "P2",
        "P3",
        "P4",
        "P5",
        "Q2",
        "Q3",
        "Q4",
        "Q5",
    ],
    [
        "J6",
        "J7",
        "J8",
        "J9",
        "M6",
        "M7",
        "M8",
        "M9",
        "P6",
        "P7",
        "P8",
        "P9",
        "Q6",
        "Q7",
        "Q8",
        "Q9",
    ],
    [
        "JC",
        "JF",
        "JG",
        "JH",
        "MC",
        "MF",
        "MG",
        "MH",
        "PC",
        "PF",
        "PG",
        "PH",
        "QC",
        "QF",
        "QG",
        "QH",
    ],
    [
        "JJ",
        "JM",
        "JP",
        "JQ",
        "MJ",
        "MM",
        "MP",
        "MQ",
        "PJ",
        "PM",
        "PP",
        "PQ",
        "QJ",
        "QM",
        "QP",
        "QQ",
    ],
    [
        "JR",
        "JV",
        "JW",
        "JX",
        "MR",
        "MV",
        "MW",
        "MX",
        "PR",
        "PV",
        "PW",
        "PX",
        "QR",
        "QV",
        "QW",
        "QX",
    ],
    [
        "R2",
        "R3",
        "R4",
        "R5",
        "V2",
        "V3",
        "V4",
        "V5",
        "W2",
        "W3",
        "W4",
        "W5",
        "X2",
        "X3",
        "X4",
        "X5",
    ],
    [
        "R6",
        "R7",
        "R8",
        "R9",
        "V6",
        "V7",
        "V8",
        "V9",
        "W6",
        "W7",
        "W8",
        "W9",
        "X6",
        "X7",
        "X8",
        "X9",
    ],
    [
        "RC",
        "RF",
        "RG",
        "RH",
        "VC",
        "VF",
        "VG",
        "VH",
        "WC",
        "WF",
        "WG",
        "WH",
        "XC",
        "XF",
        "XG",
        "XH",
    ],
    [
        "RJ",
        "RM",
        "RP",
        "RQ",
        "VJ",
        "VM",
        "VP",
        "VQ",
        "WJ",
        "WM",
        "WP",
        "WQ",
        "XJ",
        "XM",
        "XP",
        "XQ",
    ],
    [
        "RR",
        "RV",
        "RW",
        "RX",
        "VR",
        "VV",
        "VW",
        "VX",
        "WR",
        "WV",
        "WW",
        "WX",
        "XR",
        "XV",
        "XW",
        "XX",
    ],
]
